<script setup lang="ts">
const { locale, locales } = useI18n()
const { language } = useNavigatorLanguage()

// prefer the language of the user in top of the list
const sortedLocales = computed(() => {
  const lang = language.value?.split('-')[0]?.toLowerCase()
  return [...locales.value].sort((a, b) => a.code === lang ? -1 : b.code === lang ? 1 : 0)
})
</script>

<template>
  <USelect
    v-model="locale"
    :search-input="false"
    value-key="code"
    label-key="name"
    :items="sortedLocales"
    variant="ghost"
    size="xl"
    :ui="{ content: 'min-w-fit' }"
    :trailing-icon="''"
  >
    <template #leading="{ modelValue }">
      <UiLocaleFlagIcon
        v-if="modelValue"
        :code="modelValue"
      />
    </template>

    <template #item-leading="{ item }">
      <UiLocaleFlagIcon
        :code="item.code"
      />
    </template>

    <template #default="{ modelValue }">
      <span class="uppercase">{{ modelValue }}</span>
    </template>
  </USelect>
</template>
